export const PLATFORM_CAPACITOR_TYPE = {
  ANDROID: 'android',
  IOS: 'ios',
  WEB: 'web',
};
